import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@services/Logic/translate.service';

@Pipe({ name: 'translate', pure: true })
export class TranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  /**
   * @param lang otional.
   * Needed to force trigger the pipe
   * whenever the language is changed.
   */
  transform(key: any, lang?: any): any {
    const keys = key.split('.');
    let res = this.translate.data;
    keys.forEach((k) => {
      res = res[k];
    });
    return res || key;
  }
}
